import React, { useState, useEffect } from 'react';
import { INTERNAL_COMPANY } from '../../../config/constants';

type Props = {
  user?: any;
  currentUser?: any;
  onSave: (data: any) => void;
  onClose: () => void;
  companies?: any[];
};

const UserFormExterno: React.FC<Props> = ({ user, currentUser, onSave, onClose, companies }) => {
  const initialExternalName = user?.externalCompanyName ?? currentUser?.externalCompanyName ?? '';
  const [form, setForm] = useState({ name: '', email: '', password: '', role: 'ANALYST', externalCompanyName: initialExternalName });

  useEffect(() => {
    if (user) {
      setForm({ name: user.name || '', email: user.email || '', password: '', role: user.role || 'ANALYST', externalCompanyName: user.externalCompanyName || initialExternalName });
    } else {
      setForm(prev => ({ ...prev, externalCompanyName: initialExternalName }));
    }
  }, [user, initialExternalName]);

  // If companies change and no explicit externalCompanyName provided, try to default to first external company
  useEffect(() => {
    // If creating a new external user and the creator is NOT an external client,
    // default the select to the first external company (exclude internal company)
    if (!user && currentUser?.userType !== 'external') {
      const extCompanies = (companies || []).filter((c: any) => (c.name || '').trim().toLowerCase() !== INTERNAL_COMPANY.NAME.toLowerCase());
      if ((!form.externalCompanyName || form.externalCompanyName === '') && extCompanies.length > 0) {
        setForm(prev => ({ ...prev, externalCompanyName: extCompanies[0].name }));
      }
    }
  }, [companies]);

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50">
      <div className="bg-slate-900 p-6 rounded-lg w-96">
        <h3 className="text-lg font-semibold text-white mb-4">{user ? 'Editar Usuario Externo' : 'Nuevo Usuario Externo'}</h3>
        <div className="space-y-3">
          <input className="w-full p-2 rounded bg-slate-800 text-white" placeholder="Nombre" value={form.name} onChange={e => setForm(prev => ({ ...prev, name: e.target.value }))} />
          <input className="w-full p-2 rounded bg-slate-800 text-white" placeholder="Email" value={form.email} onChange={e => setForm(prev => ({ ...prev, email: e.target.value }))} />
          <input className="w-full p-2 rounded bg-slate-800 text-white" type="password" placeholder="Contraseña" value={form.password} onChange={e => setForm(prev => ({ ...prev, password: e.target.value }))} />
          <select className="w-full p-2 rounded bg-slate-800 text-white" value={form.role} onChange={e => setForm(prev => ({ ...prev, role: e.target.value }))}>
            <option value="ADMIN">ADMIN</option>
            <option value="ANALYST">ANALYST</option>
            <option value="CLIENT">CLIENT</option>
          </select>
          {/* external company select: exclude internal company, default to creator's company for external creators */}
          <select
            disabled={currentUser?.userType === 'external'}
            className="w-full p-2 rounded bg-slate-800 text-slate-300"
            value={form.externalCompanyName}
            onChange={e => setForm(prev => ({ ...prev, externalCompanyName: e.target.value }))}
          >
            <option value="">Selecciona una empresa externa</option>
              {(companies || []).filter(c => (c.name || '').trim().toLowerCase() !== INTERNAL_COMPANY.NAME.toLowerCase()).map((c: any) => (
                <option key={c.id} value={c.name}>{`${c.name} — ${c.cuit || ''}`}</option>
              ))}
          </select>
        </div>

        <div className="mt-4 flex justify-end gap-2">
          <button onClick={onClose} className="px-4 py-2 bg-slate-700 text-white rounded">Cancelar</button>
          <button
            onClick={() => onSave({ ...form, userType: 'external', externalCompanyName: form.externalCompanyName })}
            className="px-4 py-2 bg-sky-500 text-white rounded"
            disabled={!form.externalCompanyName || form.externalCompanyName.trim() === '' || !form.password || form.password.trim() === ''}
            aria-disabled={!form.externalCompanyName || form.externalCompanyName.trim() === '' || !form.password || form.password.trim() === ''}
          >
            Guardar
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserFormExterno;
